module.exports = __webpack_public_path__ + "img/4.25c625fc.jpg";